// extracted by mini-css-extract-plugin
export var button = "fp-wm";
export var buttonDarkmode = "fp-Jm";
export var buttonDisabled = "fp-Em";
export var buttonFullWidth = "fp-Dm";
export var buttonLoading = "fp-Fm";
export var buttonPrimary = "fp-Gm";
export var buttonPrimarySmall = "fp-Lm";
export var buttonSecondary = "fp-Hm";
export var buttonSmall = "fp-Km";
export var buttonTertiary = "fp-Im";
export var button__child = "fp-Nm";
export var button__loadingIcon = "fp-Mm";
export var grid = "fp-xm";
export var gridWithRowGap = "fp-ym";
export var maxWidthContainer = "fp-Cm";
export var mt0 = "fp-pm";
export var mt1 = "fp-qm";
export var mt2 = "fp-rm";
export var mt3 = "fp-sm";
export var mt4 = "fp-tm";
export var mt5 = "fp-um";
export var mt6 = "fp-vm";
export var removeVisuallyHidden = "fp-Am";
export var visuallyHidden = "fp-zm";
export var widgetBase = "fp-Bm";